import React from 'react';
import { THEME } from '../../utils/theme';

const KeyboardHelpModal = ({ onClose }) => {
  const shortcuts = [
    { keys: ['H'], desc: 'Open Help Center' },
    { keys: ['?'], desc: 'Show keyboard shortcuts' },
    { keys: ['W'], desc: 'What Should We Play? (Smart suggestions)' },
    { keys: ['R'], desc: 'Random Game Night picker' },
    { keys: ['/', 'S'], desc: 'Focus search' },
    { keys: ['F'], desc: 'Open filters' },
    { keys: ['D'], desc: 'Stats dashboard' },
    { keys: ['L'], desc: 'Toggle LFG mode' },
    { keys: ['Esc'], desc: 'Close modals / Clear selection' },
  ];

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(5,5,10,0.82)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(24px) saturate(180%)', WebkitBackdropFilter: 'blur(24px) saturate(180%)' }} onClick={onClose}>
      <div style={{ background: THEME.bgCard, borderRadius: '16px', padding: '24px', width: '90%', maxWidth: '400px', border: `1px solid ${THEME.border}`, animation: 'scaleIn 0.2s ease' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: THEME.text, fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span>⌨️</span> Keyboard Shortcuts
          </h2>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: THEME.textMuted, fontSize: '20px', cursor: 'pointer' }}>×</button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {shortcuts.map((s, idx) => (
            <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: idx < shortcuts.length - 1 ? `1px solid ${THEME.border}` : 'none' }}>
              <span style={{ color: THEME.textSecondary, fontSize: '14px' }}>{s.desc}</span>
              <div style={{ display: 'flex', gap: '4px' }}>
                {s.keys.map((key, i) => (
                  <span key={i}>
                    <kbd style={{
                      background: THEME.bgElevated,
                      color: THEME.text,
                      padding: '4px 10px',
                      borderRadius: '6px',
                      fontSize: '12px',
                      fontWeight: '600',
                      fontFamily: 'monospace',
                      border: `1px solid ${THEME.border}`
                    }}>{key}</kbd>
                    {i < s.keys.length - 1 && <span style={{ color: THEME.textDim, margin: '0 4px' }}>or</span>}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyboardHelpModal;
